import React from 'react';
import Fade from 'react-reveal/Fade';

const Description = () => {
    return (
        <Fade>
            <div className="center_wrapper">
                <h2>Highlights</h2>
                <div className="highlight_description">
                    Lorem ipsum ablbalablablablabla
                </div>
            </div>
        </Fade>
    );
};

export default Description;